import React from "react";
import {BookingFlowPageProps} from "./booking-flow-page.props";
import {observer} from "mobx-react-lite";
import {ScreenSizeBasedComponent} from "../../basic-components/layout/screen-size-based.component";
import {BookingFlowSmallScreenPage} from "./screen-small/booking-flow.small-screen.page";
import {BookingFlowLargeScreenPage} from "./screen-large/booking-flow.large-screen.page";
import {useServices} from "../../hooks/use-services.hook";
import {PayPalSdkLoader} from "./payment/paypal/paypal-sdk-loader";
import {AgencySideMenuComponent} from "../../components/agency/side-menu/agency-side-menu.component";
import {BurgerMenuComponent} from "../../components/burger-menu/burger-menu.component";

export const BookingFlowPage: React.FC<BookingFlowPageProps> = observer(props => {

    const services = useServices();

    if(!services.booking.currentPageCanBeRendered) {
        return null;
    }

    if(!services.booking.steps.currentStep?.isVisible) {
        return null;
    }

    const shouldRenderSideMenu = services.user.isAuthorized && services.configuration.isAgencyPortal;

    const renderSideMenu = () => {
        if(shouldRenderSideMenu) {
            return (
                <AgencySideMenuComponent key={"AGENCY_SIDE_MENU_COMPONENT"}/>
            )
        }
        return null;
    }

    const renderBurgerMenu = () => {
        if(shouldRenderSideMenu) {
            return (
                <BurgerMenuComponent sideMenuController={services.sideMenu.agencyMainSideMenuController}/>
            )
        }

        return null;
    }

    const getPageId = () => {
        if(shouldRenderSideMenu) {
            return services.sideMenu.agencyMainSideMenuController.contentId;
        } else {
            return undefined;
        }
    }

    const finalProps: BookingFlowPageProps = {
        pageId: getPageId(),
        ...props,
        headerOptions: {
            renderBurgerMenu: renderBurgerMenu,
            ...props.headerOptions,
        }

    }

    return (
        <PayPalSdkLoader>
            {renderSideMenu()}
            <ScreenSizeBasedComponent renderForSmallScreen={() => <BookingFlowSmallScreenPage {...finalProps}/>}
                                      renderForLargeScreen={() => <BookingFlowLargeScreenPage {...finalProps}/>}/>
        </PayPalSdkLoader>

    );
})
